import React from 'react';

const Footer: React.FC = () => {
  return (
    <React.Fragment>
      <footer id="main-footer" className="main-footer main-footer--page">
        <div className="inner">
          <p className="main-footer__copyright">Copyright &copy; SEED Co., Ltd. All Rights Reserved.</p>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer;